<template>
  <div :class="variant === 'modal' ? 'mt-3.5 px-6' : 'px-4 pt-5'">
    <MatchCompareCard v-bind="checkerWorks(finding, results)" />

    <ReportCost />

    <Alert
      v-if="checker.createError.value"
      variant="error"
      :icon="AlertIcon"
      class="mt-3.5"
    >
      {{ checker.createError.value }}
    </Alert>

    <Button
      variant="primary"
      size="lg"
      class="mt-[19px] h-10! w-full"
      :class="variant === 'sheet' && 'mb-[env(safe-area-inset-bottom)]'"
      :loading="checker.creating.value !== null"
      @click="checker.createReport"
    >
      {{
        checker.creating.value !== null
          ? `Uploading ${checker.creating.value}%`
          : 'Create report'
      }}
    </Button>
  </div>
</template>

<script setup lang="ts">
import { Alert, Button } from '@dacr/library'
import { AlertIcon } from '@dacr/icons'

import MatchCompareCard from '../match/MatchCompareCard.vue'
import ReportCost from '../match/ReportCost.vue'
import type { Finding } from './findings'
import { checkerWorks } from './material'
import type { CheckerResults } from './results'
import { useChecker } from './useChecker'

defineProps<{
  variant: 'modal' | 'sheet'
  finding: Finding
  results: CheckerResults
}>()

const checker = useChecker()
</script>
